import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	addProjects: {
		id: 'admin-pages-priority-schemes.priority-schemes-table.project-cell.add-projects',
		defaultMessage: 'Add projects',
		description: 'Button label to associate projects with a priority scheme',
	},
	totalProjectCount: {
		id: 'admin-pages-priority-schemes.priority-schemes-table.project-cell.total-project-count',
		defaultMessage: '{projectCount, plural, one {# project} other {# projects}}',
		description:
			'Button label to list the total number of projects associated with a priority scheme',
	},
});
